import type { z } from 'zod';
import {
  type MusinsaStandardResponse,
  type StandardResponse,
  type StandardResponseSchema,
  standardResponseSchema,
} from './musinsaStandardResponse';

interface StandardResponseSchemaParseParams<T, D> {
  schema: StandardResponseSchema<T>;
  data: MusinsaStandardResponse<D>;
  onError?: (error: z.ZodError) => void;
}

export const standardResponseSchemaParse = <T, D>({
  data,
  schema,
  onError,
}: StandardResponseSchemaParseParams<T, D>): StandardResponse<T> | MusinsaStandardResponse<D> => {
  const targetSchema = standardResponseSchema(schema);
  const result = targetSchema.safeParse(data);

  if (!result.success) {
    console.error(result.error.format());
    onError?.(result.error);
  }

  return result.data ?? data;
};
